<template>
    <vops-form @submit="submit()">
        <vops-slider-pane :label="label" :save-label="saveLabel">
            <v-container>
                <span>{{imageRecommendedFormat}}</span>
                <vops-filedrop v-if="images.length < maxImages" label="Add Image" extensions="jpg, jpeg, png" :maxSize="maxSize" class="mt-3" @dropped="imageDropped" />
                <v-list v-if="images.length > 0">
                    <v-list-item v-for="(image, index) in images" :key="index">
                        <v-list-item-content>
                            <v-card class="mt-2">
                                <v-card-title>
                                    <v-icon class="mr-2">mdi-camera</v-icon>
                                    {{imageTitle ? imageTitle : image.imageName}}
                                    <v-spacer/>
                                    <v-btn v-if="maxImages > 1" icon @click="setPrimary(index)" :title="primaryLabel">
                                        <v-icon v-if="image.isPrimary" color="primary">star</v-icon>
                                        <v-icon v-else color="primary">star_border</v-icon>
                                    </v-btn>
                                    <v-btn icon @click="removeImage(index)" :title="removeLabel">
                                        <v-icon color="primary">close</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-card-text class="text-center">
                                    <v-img v-if="image.hasImage"
                                           max-height="200"
                                           max-width="300"
                                           :src="getImageSrc(image)"
                                    />
                                </v-card-text>
                                <v-card-subtitle v-if="image.imageName">
                                  {{currentImageLabel}}: {{image.imageName}}
                                </v-card-subtitle>
                            </v-card>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-container>
        </vops-slider-pane>
    </vops-form>
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Emit, Prop} from "vue-property-decorator";

@Component({
    components: {}
})
export default class ImageUpdater extends Vue {
    @Prop({type:String}) label:string;
    @Prop({type:String, default:"Select"}) saveLabel:string;
    @Prop({type:String, default:"Primary"}) primaryLabel:string;
    @Prop({type:String, default:"Remove"}) removeLabel:string;
    @Prop({type:String, default:"Current Image"}) currentImageLabel:string;
    @Prop({type:Number, default:2000000}) maxSize:number;
    @Prop({type:Array, default:() => {return [{
            imageBase64: null,
            hasImage: null,
            imageUrl: null,
            isChanged: false,
            imageName: null,
            isPrimary: null,
            imageFileId: null
        }]}}) originalImages:ImageMetaData[];

    @Prop({type:String, default:null}) imageTitle:string;
    @Prop({type:String, default:"Recommended image size 275px 185px. Max file size 2MB, Format: jpg, jpeg, png"}) imageRecommendedFormat:string;
    @Prop({type:Number, default:1}) maxImages:number;

    @Emit()
    imageSelected():ImageMetaData[] {
        return this.images;
    }

    images: ImageMetaData[] = null;

    async created() {
        this.images = this.originalImages.filter(image => image.hasImage);
    }

    getImageSrc(image) {
        return image.imageUrl ? image.imageUrl : image.imageBase64;
    }

    imageDropped(image) {
        const reader = new FileReader;
        reader.onloadend = e => {
            this.images.push({
                hasImage: true,
                isChanged: true,
                imageBase64: <string>e.target.result, //(<string>e.target.result).split(',')[1],
                imageUrl: null,
                imageName: image[0].name,
                isPrimary: false,
                imageFileId: null
            });
        }
        reader.readAsDataURL(image[0]);
    }

    removeImage(index) {
        this.images.splice(index, 1);
    }

    setPrimary(index) {
        this.images[index].isChanged = true;
        this.images[index].isPrimary = true;
        this.images.forEach((image, i) => {
            if (i !== index) {
                image.isChanged = true;
                image.isPrimary = false;
            }
        });
    }

    submit() {
        this.imageSelected();
    }
}

export interface ImageMetaData {
    imageUrl: string,
    imageBase64: string,
    isChanged: boolean,
    hasImage: boolean,
    imageName: string,
    isPrimary?: boolean,
    imageFileId: string
}

</script>